import React, { Component } from 'react';
import moment from 'moment';

export class LiveClock extends Component {
  state = {
    time: null
  };

  componentWillMount() {
    this.setTime();
  }

  // Refresh time every second
  componentDidMount() {
    this.interval = setInterval(() => {
      this.setTime();
    }, 1000);
  }
  // Avoid render if time is same to keep good perfs
  shouldComponentUpdate(nextProps, { time: nextTime }) {
    const { time } = this.state;

    return time !== nextTime;
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  setTime = () => {
    this.setState({
      time: moment().format('HH[H]mm')
    });
  };

  render() {
    const { time } = this.state;

    return <span>{time}</span>;
  }
}

export default LiveClock;



// WEBPACK FOOTER //
// ./src/components/Header/LiveClock/LiveClock.jsx